import { FormikProvider, useFormik } from "formik";
import { isNull, omitBy } from "lodash";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveContactPaymentType } from "store/features/contact.store";
import DateFilter from "./components/DateFilter";
import PaymentStatusFilter from "./components/PaymentStatusFilter";
import SearchFilter from "./components/SearchFilter";
import StatusFilter from "./components/StatusFilter";
import ListFiltersLayout from "./layouts/ListFiltersLayout";
import ListFiltersSkeleton from "./skeletons/ListFiltersSkeleton";

const DEFAULT_FILTERS = {
  start: undefined,
  end: undefined,
  status: undefined,
  paymentStatus: undefined,
  search: undefined,
};

const ListFilters = ({ onFilterList, defaultFilters, isLoading, isOrder }) => {
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  const filtersForm = useFormik({
    initialValues: { ...DEFAULT_FILTERS, ...omitBy(defaultFilters, isNull) },
    onSubmit: onFilterList,
    enableReinitialize: true,
  });
  const { values: formValues, submitForm, dirty: isFormDirty } = filtersForm;

  useEffect(() => {
    if (!isFormDirty) return;
    submitForm();
  }, [isFormDirty, submitForm, formValues]);

  return (
    <FormikProvider value={filtersForm}>
      <ListFiltersLayout
        skeletonSection={isLoading && <ListFiltersSkeleton />}
        statusFilterSection={<StatusFilter isOrder={isOrder} />}
        paymentStatusFilterSection={isOrder && isCheckoutPaymentType && <PaymentStatusFilter />}
        searchFilterSection={<SearchFilter />}
        dateFilterSection={<DateFilter />}
      />
    </FormikProvider>
  );
};

ListFilters.defaultProps = {
  defaultFilters: DEFAULT_FILTERS,
  isOrder: false,
};

ListFilters.propTypes = {
  onFilterList: PropTypes.func.isRequired,
  defaultFilters: PropTypes.shape({
    start: PropTypes.oneOf([undefined, PropTypes.string]),
    end: PropTypes.oneOf([undefined, PropTypes.string]),
    status: PropTypes.oneOf([undefined, PropTypes.string]),
    paymentStatus: PropTypes.oneOf([undefined, PropTypes.string]),
    search: PropTypes.oneOf([undefined, PropTypes.string]),
  }),
  isLoading: PropTypes.bool.isRequired,
  isOrder: PropTypes.bool,
};

export default ListFilters;
